import { Box, Typography } from '@mui/material';
import React from 'react';
import FormTextField from '../../../../../shared/FormTextField';
import CustomInputLabel from '../../../../../../layout/styledcomponents/CustomInputLabel';

type Props = {
    onBehalf: boolean;
    isOwner: boolean;
    control: any;
    watch: any;
};

export default function NotesField({
    onBehalf,
    control,
    watch,
    isOwner,
}: Props) {
    const len = watch('bookingInfo.notes')?.length ?? 0;

    if (!onBehalf && isOwner) return null;

    return (
        <div>
            <Box display='flex' justifyContent='space-between'>
                <CustomInputLabel htmlFor='notes__input'>
                    Additional Notes
                </CustomInputLabel>
                {len > 0 && (
                    <Typography
                        variant='body1'
                        fontSize={'10px'}
                    >{`Characters left: ${300 - len}`}</Typography>
                )}
            </Box>

            <FormTextField
                id='notes__input'
                name='bookingInfo.notes'
                control={control}
                multiline
                rows={4}
                inputProps={{ maxLength: 300 }}
            />
        </div>
    );
}
